/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/QaUseTemplatesDialog.tsx
 * FILE_ID: JOBHUB-QA-USE-TEMPLATES-DIALOG-001
 * PURPOSE: Ask whether a quote build should use library templates.
 * WHY: This dialog opens from QA using Quotes, so No is selected.
 */
import { useEffect, useState } from 'react'
import { useIsMdUp } from '@quotech/ui'

export function QaUseTemplatesDialog({
  onCancel,
  onContinue,
}: {
  onCancel: () => void
  onContinue: (useTemplates: boolean) => void
}) {
  const [choice, setChoice] = useState(false)
  const tap = useIsMdUp() ? '' : 'min-h-[44px]'

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onCancel()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onCancel])

  return (
    <div
      className="fixed inset-0 z-40 flex items-center justify-center bg-background/70 p-4"
      role="presentation"
      onClick={onCancel}
    >
      <div
        role="dialog"
        aria-labelledby="qa-use-templates-title"
        className="w-full max-w-sm rounded-xl border border-border bg-card p-4 shadow-lg"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="qa-use-templates-title" className="text-sm font-semibold text-foreground">
          Use templates?
        </h2>
        <div className="mt-3 space-y-2">
          <label className={`flex items-center gap-2 text-sm ${tap}`}>
            <input
              type="radio"
              name="qa-use-templates"
              checked={!choice}
              onChange={() => setChoice(false)}
            />
            No
          </label>
          <label className={`flex items-center gap-2 text-sm ${tap}`}>
            <input
              type="radio"
              name="qa-use-templates"
              checked={choice}
              onChange={() => setChoice(true)}
            />
            Yes
          </label>
        </div>
        <div className="mt-4 flex flex-wrap justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className={`rounded-md px-2.5 py-1.5 text-xs text-muted-foreground ${tap}`}
          >
            Cancel
          </button>
          <button
            type="button"
            autoFocus
            onClick={() => onContinue(choice)}
            className={`rounded-md bg-primary px-2.5 py-1.5 text-xs font-medium text-primary-foreground ${tap}`}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  )
}
